<template>
    <div
      :class="className"
      :style="{ height: height, width: width }"
    >
      <a-drawer
        :title="deviceTitle"
        placement="right"
        :closable="false"
        :visible="deviceVisible"
        @close="onClose"
        width="80%"
      >
        <div>
          <a-radio-group v-model="radioValue" style="margin-bottom: 20px" @change="radioGroupChange()">
            <a-radio-button value="yin_protection_pile">阴保桩</a-radio-button>
            <a-radio-button value="electric_drainage">排流器</a-radio-button>
            <a-radio-button value="recorder">记录仪</a-radio-button>
          </a-radio-group>
        </div>
        <div v-if="radioValue==='yin_protection_pile'">
          <yinProtectionPile style="margin-top: -40px;margin-left: -21px;" :city="city" ref="yinProtectionPile"></yinProtectionPile>
        </div>
        <div v-if="radioValue==='electric_drainage'">
          <electricDrainage style="margin-top: -40px;margin-left: -21px;" :city="city" ref="electricDrainage"></electricDrainage>
        </div>
        <div v-if="radioValue==='recorder'">
          <recorder style="margin-top: -40px;margin-left: -21px;" :city="city" ref="recorder"></recorder>
        </div>
      </a-drawer>
    </div>

</template>

<script>
import * as echarts from 'echarts'
import { debounce } from '@/utils/util'
import yinProtectionPile from '../saifuneng/device/index.vue'
import electricDrainage from '../saifuneng/electric_drainage/index.vue'
import recorder from '../saifuneng/recorder/index.vue'
require('echarts/theme/macarons') // echarts theme

export default {
  name: 'Wel',
  components: {
    yinProtectionPile,
    electricDrainage,
    recorder
  },
  props: {
    className: {
      type: String,
      default: 'chart'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '300px'
    },
    autoResize: {
      type: Boolean,
      default: true
    },
    chartData: {
      type: Object,
      default: () => { return {} }
    },
    title: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      chart: null,
      deviceVisible: false,
      deviceTitle: '',
      radioValue: 'yin_protection_pile',
      city: ''
    }
  },
  watch: {
    chartData: {
      deep: true,
      handler (val) {
        this.setOptions(val)
      }
    }
  },
  mounted () {
    this.initChart()
    if (this.autoResize) {
      this.__resizeHandler = debounce(() => {
        if (this.chart) {
          this.chart.resize()
        }
      }, 100)
      window.addEventListener('resize', this.__resizeHandler)
      setTimeout(() => {
        if (this.chart) {
          this.chart.resize()
        }
      }, 600)
    }
  },
  beforeDestroy () {
    if (!this.chart) {
      return
    }
    if (this.autoResize) {
      window.removeEventListener('resize', this.__resizeHandler)
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    setOptions ({ x, y } = {}) {
      this.chart.setOption({
        tooltip: {
          trigger: 'axis'
        },
        toolbox: {
          show: true,
          feature: {
            saveAsImage: {}
          }
        },
        grid: {
          top: 30,
          bottom: 60,
          right: 0,
          left: 30
        },
        legend: {},
        // toolbox: {
        //   show: true,
        //   feature: {
        //     dataZoom: {
        //       yAxisIndex: 'none'
        //     },
        //     dataView: { readOnly: false },
        //     magicType: { type: ['line', 'bar'] },
        //     restore: {},
        //     saveAsImage: {}
        //   }
        // },
        xAxis: {
          type: 'category',
          data: x,
          axisLine: {
            lineStyle: { type: 'dashed', color: '#898a8a' }
          }
        },
        yAxis: {
          type: 'value',
          splitArea: true,
          axisLine: {
            lineStyle: { type: 'dashed', color: '#898a8a' }
          },
          splitLine: {
            show: true,
            lineStyle: { type: 'dashed', color: '#2b2c2c' }
          }
        },
        dataZoom: [
          {
            type: 'slider',
            show: true,
            xAxisIndex: [0],
            handleSize: 0, //滑动条的 左右2个滑动条的大小
            height: 10, //组件高度
            left: 550, //左边的距离
            right: 540, //右边的距离
            bottom: 506, //下面边的距离
            handleColor: '#ddd' //h滑动图标的颜色
          },
          {
            type: 'inside',
            start: 0,
            end: 50,
            textStyle: {
              color: '#fff'
            }
          },
          {
            show: true,
            type: 'slider',
            // y: '94%',
            bottom: '0',
            start: 0,
            end: 50,
            textStyle: {
              color: '#fff'
            }
          }
        ],
        series: [
          {
            name: '城市',
            type: 'bar',
            data: y,
            barWidth: 20
          }
        ]
      })
    },
    initChart () {
      this.chart = echarts.init(this.$el, 'macarons')
      this.setOptions(this.chartData)
      // 绑定柱状图点击事件
      this.chart.on('click',  (params) => {
        // 业务逻辑：弹窗/跳转/刷新表格
        // alert(`选中：${params.name}，数值：${params.value}`)
        this.deviceTitle = "【"+`${params.name}`+ '】设备列表'
        this.radioValue = 'yin_protection_pile'
        this.city = `${params.name}`
        this.$nextTick(() => {
          this.$refs.yinProtectionPile.init(this.city)
        })
        this.deviceVisible = true
      })
    },
    onClose() {
      this.deviceVisible = false
    },
    radioGroupChange() {
      this.$nextTick(() => {
        if (this.radioValue === 'yin_protection_pile') {
          this.$refs.yinProtectionPile.init(this.city)
        } else if (this.radioValue === 'electric_drainage') {
          this.$refs.electricDrainage.init(this.city)
        } else if (this.radioValue === 'recorder') {
          this.$refs.recorder.init(this.city)
        }
      })
    }
  }
}
</script>
